/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Marketing_Learn_MoreInputs */

const en_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const de_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr erfahren`)
};

const fr_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus`)
};

const es_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mas informacion`)
};

const it_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di piu`)
};

const nl_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer informatie`)
};

const pl_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz sie wiecej`)
};

const fi_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue lisaa`)
};

const da_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laes mere`)
};

const sv_consent_marketing_learn_more = /** @type {(inputs: Consent_Marketing_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las mer`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Consent_Marketing_Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_marketing_learn_more = /** @type {((inputs?: Consent_Marketing_Learn_MoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Marketing_Learn_MoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_marketing_learn_more(inputs)
	if (locale === "fr") return fr_consent_marketing_learn_more(inputs)
	if (locale === "es") return es_consent_marketing_learn_more(inputs)
	if (locale === "it") return it_consent_marketing_learn_more(inputs)
	if (locale === "nl") return nl_consent_marketing_learn_more(inputs)
	if (locale === "pl") return pl_consent_marketing_learn_more(inputs)
	if (locale === "fi") return fi_consent_marketing_learn_more(inputs)
	if (locale === "da") return da_consent_marketing_learn_more(inputs)
	if (locale === "sv") return sv_consent_marketing_learn_more(inputs)
	return en_consent_marketing_learn_more(inputs)
});